import { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import Popup from '@/sharedComponents/TextEditor/components/Popup';
import ButtonBlack from '@/sharedComponents/Button/ButtonBlack';
import { STEPS, STEP_MAP } from './constants';
import { CollectionTutorialContext, CollectionTutorialDispatchContext } from './context';
import StepDots from '../StepDots';
import styles from './CollectionTutorialPopup.module.css';

function CollectionTutorialPopup() {
  const tutorialOpen = useContext(CollectionTutorialContext);
  const settutorialOpen = useContext(CollectionTutorialDispatchContext);
  const [active, setactive] = useState(STEP_MAP.intro.key);

  useEffect(() => {
    setactive(STEP_MAP.intro.key);
  }, [tutorialOpen]);

  const next = STEPS[
    STEPS.indexOf(STEP_MAP[active]) + 1
  ]?.key;
  const back = STEPS[
    STEPS.indexOf(STEP_MAP[active]) - 1
  ]?.key;

  return (
    <Popup
      width={800}
      height={650}
      open={tutorialOpen}
      setopen={settutorialOpen}
      className="p-6"
    >
      <div className={styles.container}>
        <div>
          <div className="is-subtitle mb-3">{STEP_MAP[active].subtitle}</div>
          <div className="is-size-4 has-text-weight-medium with-text-color mb-3">
            {STEP_MAP[active].title}
          </div>
        </div>

        <div className={styles.middle}>{STEP_MAP[active].middle}</div>

        <div className={styles.bottom}>
          <div className={classNames(styles.buttons, 'is-justify-content-flex-start')}>
            {back && (
            <div
              role="none"
              className="is-subtitle with-cursor-pointer is-size-6"
              onClick={() => setactive(back)}
            >
              ← Back
            </div>
            )}
          </div>
          <div className={styles.buttons}>
            <StepDots
              dark
              className={styles.dotContainer}
              dots={STEPS}
              active={active}
              setactive={setactive}
            />
          </div>
          <div className={classNames(styles.buttons, 'is-justify-content-flex-end')}>
            <ButtonBlack onClick={next ? () => setactive(next) : () => settutorialOpen(false)}>
              {next ? 'Next →' : 'Done'}
            </ButtonBlack>
          </div>
        </div>
      </div>
    </Popup>
  );
}

export default CollectionTutorialPopup;
